import { AppRegistration, AppRegistrationCreated, AppRegistrationSecret, CreateAppRegistrationRequest } from '../models/app-registration';
import ApiService from './apiService';

class AppRegistrationService extends ApiService {
  private static instance?: AppRegistrationService;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!AppRegistrationService.instance) {
      AppRegistrationService.instance = new AppRegistrationService();
    }
    return AppRegistrationService.instance;
  }

  getAll(): Promise<AppRegistration[]> {
    return this.client.get(`/app-registrations`).then((response) => response.data);
  }

  create(request: CreateAppRegistrationRequest): Promise<AppRegistrationCreated> {
    return this.client.post(`/app-registrations`, request).then((response) => response.data);
  }

  regenerateSecret(clientId: string): Promise<AppRegistrationSecret> {
    return this.client.put(`/app-registrations/${clientId}/regenerate-secret`).then((response) => response.data);
  }

  delete(clientId: string): Promise<void> {
    return this.client.delete(`/app-registrations/${clientId}`);
  }
}

export default AppRegistrationService;
